// Función genérica para llamar al track eventos actual
export const trackEvents = (category, action, label, value = 1) => {
  if (label) {
    const dataEvent = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    };
    Domestika.event_tracking.track_event(dataEvent);
  } else {
    throw Error("No hay eventos que trackear");
  }
};

// Función genérica para eventos con datos estáticos
// Si el evento debe de incluir datos dinámicos (por ejemplo, el value de un input de formulario, como la búsqueda) mejor utilizar un método própio
export const createListenerGA = (element, event = "click", category, action, label, value = 1) => {
  if (element) {
    element.addEventListener(event, () => {
      trackEvents(category, action, label, value);
    });
  } else {
    throw Error("No hemos recibido ningún elemento sobre el que lanzar el evento.");
  }
};
